import React, { useState } from "react";

import useCustomStyles from "../../hooks/useCustomStyles";
import { accessCodesStyles } from "../../assets/styles/accessCodesStyles";
import { useSelector } from "react-redux";
import { selectState } from "../../store/slices/themeSlice";
import CustomButton from "../../components/CustomButton";

const ImportJsonTheme: React.FC = () => {
  const { theme } = useSelector(selectState);
  const [jsonContent, setJsonContent] = useState("");

  const classes = useCustomStyles(accessCodesStyles, theme);

  const handleImport = () => {
    try {
      const parsedJson = JSON.parse(jsonContent);
      console.log(parsedJson);
    } catch (error) {
      console.error("Invalid JSON format");
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <h2 className={classes.header}>Import Json Theme</h2>

        <div className={classes.buttonContainer}>
          {/* <CustomButton
            title={"Add New white label"}
            handleClick={() => {
              console.log("add new white label");
              navigate("/addNewWhiteLabel");
            }}
            name={"Add-New-White-Label"}
            loading={false}
          /> */}
        </div>
      </div>

      <div style={{ width: "50%" }}>
        <h3>Paste your JSON theme here</h3>
        <textarea
          style={{
            width: "100%",
            height: "200px",
            marginTop: "10px",
          }}
          value={jsonContent}
          onChange={(e) => setJsonContent(e.target.value)}
        />
        <CustomButton
          title={"Import Theme"}
          handleClick={handleImport}
          name={"Import-Theme"}
          loading={false}
        />
      </div>
    </div>
  );
};

export default ImportJsonTheme;
